var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSysServiceTypeBus = function SvgSysServiceTypeBus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#sysServiceTypeBus_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F8DB95",
    d: "M8 1.333A6.667 6.667 0 1 0 14.667 8 6.674 6.674 0 0 0 8 1.333ZM8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEC437",
    fillRule: "evenodd",
    d: "M4.404 4.682c0-.56.454-1.014 1.014-1.014h5.164c.56 0 1.014.454 1.014 1.014v5.9c0 .561-.454 1.015-1.014 1.015H5.418c-.56 0-1.014-.454-1.014-1.014v-5.9Zm1.014-.46a.461.461 0 0 0-.46.46v5.9c0 .255.206.462.46.462h5.164a.461.461 0 0 0 .46-.461v-5.9a.461.461 0 0 0-.46-.462H5.418Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEC437",
    fillRule: "evenodd",
    d: "M4.404 5.05c0-.153.124-.277.277-.277h6.638c.153 0 .277.124.277.277v3.32a.277.277 0 0 1-.277.276H4.681a.277.277 0 0 1-.277-.277V5.05Zm.553.277v2.766h6.086V5.327H4.957ZM5.14 11.597c0-.153.124-.277.277-.277h1.107c.152 0 .276.124.276.277v.369a.645.645 0 0 1-.645.645h-.369a.645.645 0 0 1-.645-.645v-.37Zm.554.277v.092c0 .05.041.092.092.092h.369c.05 0 .092-.041.092-.092v-.092h-.553ZM9.197 11.597c0-.153.124-.277.277-.277h1.106c.153 0 .277.124.277.277v.369a.645.645 0 0 1-.646.645h-.368a.645.645 0 0 1-.646-.645v-.37Zm.553.277v.092c0 .05.042.092.093.092h.368c.051 0 .093-.041.093-.092v-.092H9.75Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEC437",
    fillRule: "evenodd",
    d: "M11.041 5.788c0-.152.124-.276.277-.276h.368c.357 0 .646.289.646.645v1.106a.277.277 0 1 1-.553 0V6.157a.092.092 0 0 0-.093-.092h-.368a.277.277 0 0 1-.277-.277ZM4.957 5.788a.277.277 0 0 0-.277-.276h-.369a.645.645 0 0 0-.645.645v1.106a.277.277 0 1 0 .553 0V6.157c0-.05.041-.092.092-.092h.37a.277.277 0 0 0 .276-.277ZM4.404 8.648c0-.153.124-.277.277-.277h.737c.56 0 1.015.454 1.015 1.014v.37a.277.277 0 0 1-.277.276H4.681a.277.277 0 0 1-.277-.277V8.648Zm.553.276v.553h.922v-.092a.461.461 0 0 0-.46-.46h-.462ZM11.595 8.648a.277.277 0 0 0-.277-.277h-.737c-.56 0-1.015.454-1.015 1.014v.37c0 .152.124.276.277.276h1.475a.277.277 0 0 0 .277-.277V8.648Zm-.553.276v.553h-.922v-.092c0-.254.206-.46.46-.46h.462Z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "sysServiceTypeBus_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgSysServiceTypeBus;